/* Megaprintery — storefront behaviour.
   Variant picking, gallery, cart, drawer, rails, dossier tabs, the scrolling hall,
   and the generated stand figures. Nothing here invents a price: every figure on
   screen comes from Shopify. */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MPD = window.MP || {};

  function money(cents) {
    var fmt = MPD.money || "${{amount}}";
    var n = (cents / 100);
    function withCommas(v, dec) {
      var p = v.toFixed(dec).split(".");
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (p[1] ? "." + p[1] : "");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      if (k === "amount") return withCommas(n, 2);
      if (k === "amount_no_decimals") return withCommas(n, 0);
      if (k === "amount_with_comma_separator") return withCommas(n, 2).replace(/,/g, " ").replace(".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return withCommas(n, 0).replace(/,/g, " ");
      return withCommas(n, 2);
    });
  }

  /* ══════ drawer ══════ */
  (function () {
    var scrim = $("#scrim");
    function open(el) {
      el.classList.add("on"); el.setAttribute("aria-hidden", "false");
      if (scrim) { scrim.hidden = false; scrim.classList.add("on"); }
      document.body.classList.add("locked");
      var f = el.querySelector("a,button"); if (f) f.focus();
    }
    function close(el) {
      el.classList.remove("on"); el.setAttribute("aria-hidden", "true");
      if (scrim) { scrim.classList.remove("on"); scrim.hidden = true; }
      document.body.classList.remove("locked");
    }
    $$("[data-drawer-open]").forEach(function (b) {
      b.addEventListener("click", function () {
        var el = document.getElementById(b.getAttribute("data-drawer-open"));
        if (el) open(el);
      });
    });
    $$("[data-drawer-close]").forEach(function (b) {
      b.addEventListener("click", function () {
        var el = b.closest(".drawer"); if (el) close(el);
      });
    });
    if (scrim) scrim.addEventListener("click", function () { $$(".drawer.on").forEach(close); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") $$(".drawer.on").forEach(close);
    });
  })();

  /* ══════ the sticky header ══════ ═══════════════════════════════════════════
     Shopify wraps each section in a div of its own height, and a sticky element
     inside a wrapper that tight has nowhere to travel — so the header was
     scrolling away. Stick the wrapper, then publish the header's measured
     height as --headh: the product rail, the filter bar and every anchor
     offset in the stylesheet are set from that one number. ─────────────────*/
  (function () {
    var head = $(".site-head");
    if (!head) return;
    var wrap = head.parentElement;
    if (wrap && wrap.classList.contains("shopify-section")) wrap.classList.add("stickhead");
    function fit() {
      document.documentElement.style.setProperty("--headh", head.offsetHeight + "px");
    }
    fit();
    window.addEventListener("resize", fit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  /* ══════ generated stand figures ══════ ═══════════════════════════════════
     A page of cards can carry fifty diagrams. Drawing them all at boot blocks
     the main thread for hundreds of milliseconds and the first scroll stutters.
     So: load the engine only when a figure is actually approaching the
     viewport, then draw one figure per idle slice.
     ────────────────────────────────────────────────────────────────────────*/
  var ENGINE_SRC = document.currentScript ? null : null;
  var engineWanted = false, enginePromise = null;

  function loadEngine() {
    if (window.MPEngine) return Promise.resolve(window.MPEngine);
    if (enginePromise) return enginePromise;
    var src = document.documentElement.getAttribute("data-mp-engine");
    if (!src) return Promise.resolve(null);
    enginePromise = new Promise(function (res) {
      var t = document.createElement("script");
      t.src = src;
      t.async = true;
      t.onload = function () { res(window.MPEngine || null); };
      t.onerror = function () { res(null); };
      document.head.appendChild(t);
    });
    return enginePromise;
  }

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(function () {
    fn({ timeRemaining: function () { return 8; } });
  }, 1); };

  var queue = [], draining = false;

  function drawOne(svg) {
    if (!window.MPEngine || svg.dataset.mpDrawn === "1") return;
    var spec;
    try { spec = JSON.parse(svg.getAttribute("data-mp-stand")); } catch (e) { return; }
    var box = svg.parentNode;
    var w = Math.max(320, box.clientWidth || 640);
    var h = Math.max(240, box.clientHeight || Math.round(w * 0.75));
    var full = {
      w: +spec.w || 10, d: +spec.d || 10, h: +spec.h || 8,
      arch: spec.arch || "linear", lit: spec.lit || "none",
      sides: 1, finish: "brushed",
      /* no printed colour: the panels are shown unprinted, which is what the
         product actually ships as, and keeps a grid of diagrams consistent */
      brand: null,
      room: (spec.arch === "island" && (+spec.w) >= 19) ? 1 : 0,
      ring: spec.arch === "island" ? 1 : 0,
      ceiling: 0, counter: 0, counterLit: 0, tower: 0, mon85: 0, mon49: 0,
      shelf: 0, litstand: 0, tablet: 0, deck: 0, spare: 0, flight: 0,
      rush: 0, install: 0, storage: 0, warranty10: 0, dmx: 0, power: 0
    };
    try {
      var cfg = window.MPEngine.mkCfg(full);
      /* a scale figure helps on the large product view and is noise on a card */
      if (!spec.scale) cfg.people = [];
      window.MPEngine.drawBooth(svg, cfg, full.lit, { frame: [w, h], pad: 0.06 });
      svg.dataset.mpDrawn = "1";
      /* remember the scene so the figure can be turned without rebuilding it */
      svg.__mp = { cfg: cfg, lit: full.lit, pad: 0.06 };
      if (spec.spin) makeSpinner(svg);
    } catch (e) { /* a figure is decoration; never break the page for it */ }
  }

  function drain(deadline) {
    draining = true;
    /* One figure per idle slice. A booth is tens of milliseconds to draw, so a
       loop that starts another one with 4ms left on the clock overruns the
       frame — and an overrun during a scroll is exactly what is felt. */
    if (queue.length) drawOne(queue.shift());
    if (queue.length && deadline && deadline.timeRemaining() > 24) drawOne(queue.shift());
    if (queue.length) idle(drain);
    else draining = false;
  }

  function enqueue(svg) {
    if (svg.dataset.mpDrawn === "1" || svg.dataset.mpQueued === "1") return;
    svg.dataset.mpQueued = "1";
    queue.push(svg);
    loadEngine().then(function (eng) { if (eng && !draining) idle(drain); });
  }

  /* Observe the box the diagram sits in, not the diagram: a target inside a
     content-visibility:auto subtree never reports an intersection. */
  function figIn(el) { return el.matches("[data-mp-stand]") ? el : el.querySelector("[data-mp-stand]"); }

  var figIO = ("IntersectionObserver" in window)
    ? new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          figIO.unobserve(x.target);
          var svg = figIn(x.target);
          if (svg) enqueue(svg);
        });
      }, { rootMargin: "500px 0px" })
    : null;

  function drawFigures() {
    var figs = $$("[data-mp-stand]");
    if (!figs.length) return;
    if (!figIO) { figs.forEach(enqueue); return; }
    figs.forEach(function (svg) {
      if (svg.dataset.mpDrawn === "1" || svg.dataset.mpQueued === "1") return;
      figIO.observe(svg.parentNode && svg.parentNode.nodeType === 1 ? svg.parentNode : svg);
    });
  }

  /* Belt and braces: whatever the observer misses, a scroll sweep catches. */
  (function () {
    var pending = false;
    function sweep() {
      pending = false;
      var vh = window.innerHeight;
      $$("[data-mp-stand]").forEach(function (svg) {
        if (svg.dataset.mpDrawn === "1" || svg.dataset.mpQueued === "1") return;
        var r = (svg.parentNode.getBoundingClientRect ? svg.parentNode : svg).getBoundingClientRect();
        if (r.bottom > -600 && r.top < vh + 600) enqueue(svg);
      });
    }
    var t;
    window.addEventListener("scroll", function () {
      if (pending) return;
      pending = true;
      clearTimeout(t);
      t = setTimeout(sweep, 180);
    }, { passive: true });
  })();

  function redrawDrawn() {
    $$("[data-mp-stand][data-mp-drawn='1']").forEach(function (svg) {
      svg.dataset.mpDrawn = "";
      svg.dataset.mpQueued = "";
      enqueue(svg);
    });
  }

  /* ══════ product: variants ══════ */
  (function () {
    var form = $("[data-pdp-form]");
    if (!form) return;
    var addons = initAddons(form);
    var node = $("[data-variant-json]");
    var variants = [];
    try { variants = JSON.parse(node.textContent); } catch (e) { return; }

    var idInput = $("[data-v-id]", form);
    var priceEl = $("[data-v-price]", form);
    var wasEl = $("[data-v-was]", form);
    var btn = $("[data-add-btn]", form);
    var btnLabel = $("[data-add-label]", form);
    var stage = $("[data-gal-stage]");

    function chosen() {
      var out = [];
      $$("[data-opt-radio]", form).forEach(function (r) { if (r.checked) out[+r.getAttribute("data-opt-radio") - 1] = r.value; });
      $$("[data-opt-select]", form).forEach(function (s) { out[+s.getAttribute("data-opt-select") - 1] = s.value; });
      return out;
    }

    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== undefined && v.opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Not every combination exists: the factory does not build every fabric in
       every size, and we only list a size we have a real price for. So each
       option value is checked against the rest of the current selection, and
       anything that cannot be built is shown as unavailable rather than
       silently snapping the reader to a different stand. */
    function possible(pos, value, sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = v.opts[pos] === value;
        if (!ok) continue;
        for (var j = 0; j < sel.length; j++) {
          if (j === pos || sel[j] === undefined) continue;
          if (v.opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function markAvailability(sel) {
      $$("[data-opt-radio]", form).forEach(function (r) {
        var pos = +r.getAttribute("data-opt-radio") - 1;
        var can = possible(pos, r.value, sel);
        r.disabled = !can;
        var lab = r.closest("label");
        if (lab) lab.classList.toggle("gone", !can);
      });
      $$("[data-opt-select]", form).forEach(function (s) {
        var pos = +s.getAttribute("data-opt-select") - 1;
        $$("option", s).forEach(function (o) {
          var can = possible(pos, o.value, sel);
          o.disabled = !can;
          o.textContent = o.textContent.replace(/ — not in this build$/, "");
          if (!can) o.textContent += " — not in this build";
        });
      });
    }

    /* When a pick leaves no buildable stand, keep the pick the reader just made
       and move the earlier one to something that works with it. */
    function reconcile(sel, lastPos) {
      if (match(sel)) return sel;
      for (var j = 0; j < sel.length; j++) {
        if (j === lastPos || sel[j] === undefined) continue;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (lastPos != null && v.opts[lastPos] !== sel[lastPos]) continue;
          var trial = sel.slice(); trial[j] = v.opts[j];
          if (match(trial)) return trial;
        }
      }
      for (var k = 0; k < variants.length; k++) {
        if (lastPos == null || variants[k].opts[lastPos] === sel[lastPos]) {
          return variants[k].opts.slice();
        }
      }
      return sel;
    }

    function applySel(sel) {
      $$("[data-opt-radio]", form).forEach(function (r) {
        var pos = +r.getAttribute("data-opt-radio") - 1;
        r.checked = (r.value === sel[pos]);
      });
      $$("[data-opt-select]", form).forEach(function (s) {
        var pos = +s.getAttribute("data-opt-select") - 1;
        if (sel[pos] !== undefined) s.value = sel[pos];
      });
    }

    var lastPos = null;

    function paint() {
      var sel = reconcile(chosen(), lastPos);
      applySel(sel);
      markAvailability(sel);
      var v = match(sel) || variants[0];
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare && v.compare > v.price) { wasEl.textContent = money(v.compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      $$("[data-v-sku]").forEach(function (el) { el.textContent = v.sku || ""; });
      $$("[data-rail-price]").forEach(function (el) { el.textContent = money(v.price); });
      $$("[data-opt-current]").forEach(function (el) {
        var i = +el.getAttribute("data-opt-current") - 1;
        el.textContent = sel[i] || "";
      });
      /* the custom-size enquiry lower down the page opens on whatever is
         selected up here, so nobody has to retype the configuration */
      var picked = sel.filter(function (x) { return x; }).join(" · ");
      $$("[data-enq-size]").forEach(function (f) { f.value = picked; });
      $$("[data-enq-ref]").forEach(function (f) { f.value = v.sku || ""; });
      if (btn) {
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? (btn.dataset.label || btnLabel.dataset.on || btnLabel.textContent) : "Unavailable";
        if (!v.available && btnLabel) btnLabel.textContent = "Unavailable";
      }
      if (v.img && stage) {
        var img = stage.querySelector("img");
        if (img) img.src = v.img;
      }
      /* keep the address bar honest so a shared link opens the same variant */
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }

    var onLabel = btnLabel ? btnLabel.textContent : "Add to order";
    if (btnLabel) btnLabel.dataset.on = onLabel;

    $$("[data-opt-radio],[data-opt-select]", form).forEach(function (el) {
      el.addEventListener("change", function () {
        lastPos = +(el.getAttribute("data-opt-radio") || el.getAttribute("data-opt-select")) - 1;
        paint();
      });
    });

    $$("[data-qty]", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var input = $("input[name=quantity]", form);
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + (+b.getAttribute("data-qty")));
        input.value = n;
      });
    });

    /* gallery */
    $$("[data-gal-thumb]").forEach(function (b) {
      b.addEventListener("click", function () {
        var src = b.getAttribute("data-gal-thumb");
        var img = stage && stage.querySelector("img");
        if (img) img.src = src;
        $$("[data-gal-thumb]").forEach(function (o) { o.setAttribute("aria-current", o === b ? "true" : "false"); });
      });
    });

    /* add to cart without leaving the page */
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var fd = new FormData(form);
      var extras = addons ? addons.selected() : [];
      if (extras.length) {
        /* one request, many lines: Shopify takes id+quantity OR items[], never both */
        var qty = fd.get("quantity") || 1;
        var mainId = fd.get("id");
        fd = new FormData();
        fd.append("form_type", "product");
        fd.append("utf8", "\u2713");
        fd.append("items[0][id]", mainId);
        fd.append("items[0][quantity]", qty);
        extras.forEach(function (id, i) {
          fd.append("items[" + (i + 1) + "][id]", id);
          fd.append("items[" + (i + 1) + "][quantity]", 1);
        });
      }
      if (btnLabel) btnLabel.textContent = "Adding…";
      fetch(MPD.routes.cart_add, {
        method: "POST", body: fd,
        headers: { "Accept": "application/javascript" }
      }).then(function (r) { return r.json(); })
        .then(function () { return fetch("/cart.js", { headers: { "Accept": "application/json" } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$("[data-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
          });
          if (btnLabel) btnLabel.textContent = "Added";
          setTimeout(function () { if (btnLabel) btnLabel.textContent = btnLabel.dataset.on; }, 1600);
        })
        .catch(function () { form.submit(); });
    });

    paint();
  })();

  /* ══════ product: the quoted configuration ══════ ═════════════════════════
     A quoted product has no variants to switch, so what the visitor picks has
     to travel with them: into the hidden fields of the enquiry, into the line
     above the send button, and into the button on the buy box, so the page
     always says back exactly what is being priced. ─────────────────────────*/
  (function () {
    var picks = $$("[data-choose]");
    if (!picks.length) return;
    var chosen = {};
    var cta = $("[data-quote-cta] span");
    var ctaBase = cta ? cta.textContent : "";
    var echo = $("[data-enq-echo]");

    function label(k) {
      var el = $("[data-choose-current='" + k + "']");
      if (el) el.textContent = chosen[k] || "Choose one";
      var f = $("[data-enq-" + k + "]");
      if (f) f.value = chosen[k] || "";
    }
    function paint() {
      var bits = [];
      if (chosen.size) bits.push(chosen.size);
      if (chosen.hardware) bits.push(chosen.hardware);
      if (echo) {
        echo.hidden = !bits.length;
        echo.textContent = bits.length
          ? "Pricing " + document.title.split(" · ")[0] + " — " + bits.join(" · ")
          : "";
      }
      if (cta) cta.textContent = bits.length ? "Price " + bits.join(" · ") : ctaBase;
    }
    picks.forEach(function (el) {
      el.addEventListener("change", function () {
        var k = el.getAttribute("data-choose");
        chosen[k] = el.value || "";
        label(k);
        paint();
      });
    });
  })();

  /* ══════ product: the reader's rail ══════ ═════════════════════════════════
     A long product page is five sections deep. The rail keeps the reader's
     place in it, and once the buy box has scrolled away it carries the live
     price back to the top — so the price is never more than one glance away.
     One rAF-throttled read per scroll, no layout thrash. ────────────────────*/
  (function () {
    var rail = $("[data-pdp-rail]");
    if (!rail) return;
    var links = $$("[data-pdp-link]", rail);
    var track = $("[data-pdp-track]", rail);
    if (!links.length) return;

    var secs = links.map(function (a) {
      return document.getElementById(a.getAttribute("data-pdp-link"));
    });
    var form = $("[data-pdp-form]");
    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var cur = -1;

    function mark(i) {
      if (i === cur) return;
      cur = i;
      for (var n = 0; n < links.length; n++) {
        links[n].setAttribute("aria-current", n === i ? "true" : "false");
      }
      var a = links[i];
      if (!a || !track || track.scrollWidth <= track.clientWidth + 4) return;
      var want = a.offsetLeft - (track.clientWidth - a.offsetWidth) / 2;
      want = Math.max(0, want);
      if (track.scrollTo) track.scrollTo({ left: want, behavior: still ? "auto" : "smooth" });
      else track.scrollLeft = want;
    }

    /* The line to measure against is where the rail sits once it is stuck —
       under the sticky header — not where the rail happens to be while it is
       still further down the page. */
    var head = $(".site-head");
    function stickline() {
      var top = 0;
      if (head) {
        var hb = head.getBoundingClientRect().bottom;
        if (hb > 0) top = hb;
      }
      return top + rail.offsetHeight;
    }

    var queued = false;
    function read() {
      queued = false;
      if (track) track.classList.toggle("ovf", track.scrollWidth > track.clientWidth + 4);
      var L = stickline();
      var found = 0;
      for (var i = 0; i < secs.length; i++) {
        if (secs[i] && secs[i].getBoundingClientRect().top <= L + 20) found = i;
      }
      mark(found);
      if (form) {
        rail.classList.toggle("past", form.getBoundingClientRect().bottom < L);
      }
    }
    function tick() { if (!queued) { queued = true; requestAnimationFrame(read); } }

    /* rAF batches the reads during the scroll; the settle timer is insurance
       for the environments that throttle rAF, so the rail always agrees with
       the page once scrolling stops. */
    var settle;
    window.addEventListener("scroll", function () {
      tick();
      clearTimeout(settle);
      settle = setTimeout(read, 120);
    }, { passive: true });
    window.addEventListener("resize", tick, { passive: true });
    read();

    /* An anchor click should not wait for the scroll to settle before the rail
       agrees with it. */
    links.forEach(function (a) {
      a.addEventListener("click", function () {
        mark(links.indexOf(a));
      });
    });
  })();

  /* ══════ cart page ══════ */
  (function () {
    if (!$(".citems")) return;
    function change(key, qty) {
      fetch(MPD.routes.cart_change, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { location.reload(); });
    }
    $$("[data-cart-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.getAttribute("data-key");
        var input = $('[data-cart-input][data-key="' + key + '"]');
        var n = Math.max(0, (parseInt(input.value, 10) || 0) + (+b.getAttribute("data-cart-qty")));
        change(key, n);
      });
    });
    $$("[data-cart-remove]").forEach(function (b) {
      b.addEventListener("click", function () { change(b.getAttribute("data-key"), 0); });
    });
  })();

  /* ══════ family rail ══════ */
  (function () {
    var rail = $("#fams");
    if (!rail) return;
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      $$("[data-rail]").forEach(function (b) {
        b.disabled = (+b.dataset.rail < 0) ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
        b.style.opacity = b.disabled ? ".35" : "1";
      });
    }
    $$("[data-rail]").forEach(function (b) {
      b.addEventListener("click", function () {
        var card = rail.querySelector(".fam");
        var step = card ? card.getBoundingClientRect().width + 1 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: step * (+b.dataset.rail), behavior: "smooth" });
      });
    });
    rail.addEventListener("scroll", sync);
    window.addEventListener("resize", sync);
    setTimeout(sync, 300);
  })();

  /* ══════ dossier tabs ══════ */
  (function () {
    var tabs = $$("[data-dos]");
    if (!tabs.length) return;
    function show(i) {
      tabs.forEach(function (t, k) {
        t.setAttribute("aria-selected", k === i ? "true" : "false");
        var panel = document.getElementById("dos" + k);
        if (!panel) return;
        panel.hidden = k !== i;
        panel.classList.toggle("on", k === i);
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(i); });
      t.addEventListener("keydown", function (e) {
        var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + tabs.length) % tabs.length;
        tabs[n].focus(); show(n);
      });
    });
  })();

  /* ══════ the hall, driven by the scroll ══════ ═══════════════════════════
     Three photographs of a real show floor, cross-faded against the scroll.

     What replaced what: this used to paint a synthetic hall to a <canvas>,
     sixty times a second, and the whole apparatus — a detail ladder, a
     resolution ladder, a frame-cost governor — existed to keep that honest on
     a slow machine. Photographs need none of it. The browser decodes three
     JPEGs once and the scroll then touches nothing but opacity, transform and
     filter, all of which the compositor owns. There is no per-frame layout,
     no per-frame paint, and nothing to degrade.

     One number does everything: the section's scroll progress. It picks the
     lit frame, eases that frame's push, moves the caption and fills the bar.
     Read once per rAF, written once per rAF.
     ─────────────────────────────────────────────────────────────────────*/
  function initHall() {
    var sec = $("#floor");
    if (!sec || sec.dataset.mpHall === "1") return;
    var wrap = $("[data-hall]", sec);
    if (!wrap) return;
    sec.dataset.mpHall = "1";

    var shots = $$("[data-hall-frame]", wrap);
    var caps = $$(".fcap", sec), bar = $("#fBar"), kick = $("#fKick");
    var sweep = $("[data-hall-sweep]", wrap);
    var vid = $("[data-hall-video]", wrap);
    var labels = caps.map(function (c) { return c.getAttribute("data-kicker") || ""; });
    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!shots.length) return;

    /* Where each frame sits in the scroll and how far it pushes while it is
       lit. Different distances and directions on purpose: four identical
       pushes read as a slideshow, four different ones read as one move
       through a hall. */
    var MOVE = [
      { z0: 1.06, z1: 1.15, px: 0,    py: -1.4 },
      { z0: 1.16, z1: 1.05, px: -2.4, py: 0 },
      { z0: 1.04, z1: 1.14, px: 1.9,  py: -0.8 },
      { z0: 1.14, z1: 1.05, px: -1.4, py: 0.9 }
    ];

    var n = shots.length;
    var cur = -1, capNow = -1, raf = 0, live = false, sweepT = 0;

    /* The video is the one heavy thing on the page, so it has to earn its
       download: wide screens only, motion allowed, and no data-saver. Anywhere
       else the poster still is the frame and nothing is fetched. */
    function wantsVideo() {
      if (!vid || still) return false;
      if (!vid.getAttribute("data-src")) return false;
      if (innerWidth < 760) return false;
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ""))) return false;
      return true;
    }
    var vidArmed = false;
    function armVideo() {
      if (vidArmed || !wantsVideo()) return;
      vidArmed = true;
      vid.src = vid.getAttribute("data-src");
      vid.load();
    }
    function playVideo(on) {
      if (!vidArmed) return;
      if (on) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      else vid.pause();
    }

    function progress() {
      var r = sec.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      if (span <= 0) return 0;
      var t = -r.top / span;
      return t < 0 ? 0 : (t > 1 ? 1 : t);
    }

    function paint() {
      raf = 0;
      var t = progress();

      var slot = t * n;
      var idx = Math.floor(slot);
      if (idx > n - 1) idx = n - 1;
      var local = slot - idx;

      if (idx !== cur) {
        shots.forEach(function (f, i) { f.classList.toggle("on", i === idx); });
        /* the blade only crosses on a real change, and never twice inside its
           own run — retriggering mid-animation reads as a flicker */
        if (sweep && !still && cur !== -1) {
          var now = performance.now();
          if (now - sweepT > 900) {
            sweepT = now;
            sweep.classList.remove("cut");
            void sweep.offsetWidth;
            sweep.classList.add("cut");
          }
        }
        playVideo(idx === 0);
        cur = idx;
      }

      /* The push is never written onto the video frame. A <video> that is
         decoding and also having its transform rewritten every frame forces a
         re-composite of the whole layer — measured at 39 dropped frames out of
         191 on a 1440px desktop. The clip is already moving; it does not need
         a scroll push on top. */
      if (!still) {
        var m = MOVE[idx] || MOVE[0];
        var k = local < 0 ? 0 : (local > 1 ? 1 : local);
        var el = shots[idx].firstElementChild;
        if (el && el.tagName !== "VIDEO") {
          el.style.setProperty("--z", (m.z0 + (m.z1 - m.z0) * k).toFixed(4));
          el.style.setProperty("--px", ((m.px || 0) * k).toFixed(2) + "%");
          el.style.setProperty("--py", ((m.py || 0) * k).toFixed(2) + "%");
        }
      }

      if (caps.length) {
        var ci = Math.min(caps.length - 1, Math.floor(t * caps.length));
        if (ci !== capNow) {
          caps.forEach(function (c, i) { c.classList.toggle("on", i === ci); });
          if (kick && labels[ci]) kick.textContent = labels[ci];
          capNow = ci;
        }
      }
      if (bar) bar.style.transform = "scaleX(" + t.toFixed(4) + ")";
    }

    function onScroll() { if (live && !raf) raf = requestAnimationFrame(paint); }

    /* Nothing is bound until the hall is close, and everything is unbound when
       it leaves: a scroll listener running the length of the page is exactly
       the friction this section was rebuilt to remove. */
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          live = x.isIntersecting;
          if (live) { armVideo(); paint(); playVideo(cur === 0); }
          else playVideo(false);
        });
      }, { rootMargin: "700px 0px" }).observe(sec);
    } else {
      live = true;
    }

    addEventListener("scroll", onScroll, { passive: true });
    addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("visibilitychange", function () {
      playVideo(!document.hidden && live && cur === 0);
    });
    paint();
  }

  /* ══════ reveal on scroll ══════ */
  (function () {
    var rvs = $$(".rv");
    if (!rvs.length) return;
    if (!("IntersectionObserver" in window) ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      rvs.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } });
    }, { threshold: 0.05, rootMargin: "0px 0px -4% 0px" });
    rvs.forEach(function (e) { io.observe(e); });
  })();




  /* ══════ drag to rotate ══════ ════════════════════════════════════════════
     Two places on the page carry a "Drag to rotate" hint. A hint that does
     nothing is worse than no hint, so this is what makes it true: horizontal
     drag turns the camera, the redraw is rAF-throttled and drawn lean while
     the pointer is down, and the full-quality frame lands on release. Arrow
     keys do the same thing for anyone not using a pointer.
     ────────────────────────────────────────────────────────────────────────*/
  var SPIN_STEP = 0.075;         /* radians per arrow-key press */
  var SPIN_RATE = 0.0028;        /* radians per pixel of drag */
  var SPIN_MIN = -1.62, SPIN_MAX = 0.36, SPIN_HOME = -0.62;

  function makeSpinner(svg) {
    if (!svg || svg.__mpSpin) return;
    var stage = svg.closest(".spin, .featstage, .stage");
    if (!stage) return;
    svg.__mpSpin = true;
    stage.classList.add("spinnable");

    var yaw = (svg.__mp && svg.__mp.yaw !== undefined) ? svg.__mp.yaw : SPIN_HOME;
    if (svg.__mp) svg.__mp.yaw = yaw;
    var raf = null, lean = false, settle = null;

    function render() {
      raf = null;
      var h = svg.__mp;
      if (!h || !window.MPEngine) return;
      var box = svg.parentNode;
      var w = Math.max(280, box.clientWidth || 640);
      var ht = Math.max(200, box.clientHeight || Math.round(w * 0.75));
      try {
        window.MPEngine.drawBooth(svg, h.cfg, h.lit,
          { frame: [w, ht], pad: h.pad || 0.06, yaw: yaw, lean: lean });
        h.yaw = yaw;
      } catch (e) { /* never let a turn break the page */ }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(render); }
    function set(next) {
      yaw = Math.max(SPIN_MIN, Math.min(SPIN_MAX, next));
      queue();
    }
    function settleSoon() {
      clearTimeout(settle);
      settle = setTimeout(function () { lean = false; queue(); }, 130);
    }

    var id = null, x0 = 0, y0 = 0, yaw0 = 0, decided = false;

    stage.addEventListener("pointerdown", function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target.closest("a,button,input,select,label,textarea")) return;
      id = e.pointerId; x0 = e.clientX; y0 = e.clientY; yaw0 = yaw; decided = false;
      stage.classList.add("spinning");
      if (stage.setPointerCapture) { try { stage.setPointerCapture(id); } catch (er) {} }
    });

    stage.addEventListener("pointermove", function (e) {
      if (id === null || e.pointerId !== id) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!decided) {
        /* let a vertical swipe scroll the page instead of turning the stand */
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { id = null; stage.classList.remove("spinning"); return; }
        decided = true;
      }
      if (e.cancelable) e.preventDefault();
      lean = true;
      set(yaw0 - dx * SPIN_RATE);
    }, { passive: false });

    function release(e) {
      if (id === null || (e && e.pointerId !== undefined && e.pointerId !== id)) return;
      id = null;
      stage.classList.remove("spinning");
      settleSoon();
    }
    stage.addEventListener("pointerup", release);
    stage.addEventListener("pointercancel", release);
    stage.addEventListener("lostpointercapture", release);

    /* keyboard: the stage is focusable so the figure can be turned without a pointer */
    if (!stage.hasAttribute("tabindex")) stage.setAttribute("tabindex", "0");
    stage.setAttribute("role", stage.getAttribute("role") || "group");
    stage.setAttribute("aria-label", stage.getAttribute("aria-label") || "Drag or use the arrow keys to turn the stand");
    stage.addEventListener("keydown", function (e) {
      var k = e.key;
      if (k !== "ArrowLeft" && k !== "ArrowRight" && k !== "Home") return;
      e.preventDefault();
      lean = false;
      if (k === "Home") set(SPIN_HOME);
      else set(yaw + (k === "ArrowLeft" ? SPIN_STEP : -SPIN_STEP));
    });

    /* double tap / double click returns it to the house angle */
    stage.addEventListener("dblclick", function () { lean = false; set(SPIN_HOME); });
  }

  /* ══════ product add-ons ══════ ═══════════════════════════════════════════
     Ticked companions are real products. They are appended to the SAME
     /cart/add request as the stand, in Shopify's items[] form, so one click
     produces one order containing exactly the lines the customer ticked. ────*/
  function initAddons(form) {
    var list = $("[data-addon-list]");
    if (!list) return null;
    var bom = $("[data-bom]"), extra = $("[data-bom-extra]"),
        totalEl = $("[data-bom-total]"), baseEl = $("[data-bom-base-price]");
    var rows = $$("[data-addon]", list);
    if (!rows.length) return null;

    function basePrice() {
      var el = $("[data-v-price]");
      if (!el) return 0;
      var n = el.textContent.replace(/[^0-9.,]/g, "").replace(/,/g, "");
      return Math.round(parseFloat(n) * 100) || 0;
    }
    function fmt(cents) {
      var el = $("[data-v-price]");
      var sample = el ? el.textContent.trim() : "$0.00";
      var sym = sample.replace(/[0-9.,\s]/g, "") || "$";
      return sym + (cents / 100).toLocaleString(undefined,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function sync() {
      var chosen = rows.filter(function (r) { return r.checked; });
      if (extra) extra.innerHTML = "";
      var sum = basePrice();
      chosen.forEach(function (r) {
        var cents = parseInt(r.getAttribute("data-addon-price"), 10) || 0;
        sum += cents;
        if (!extra) return;
        var d = document.createElement("div");
        d.className = "r";
        var a = document.createElement("span");
        a.textContent = r.getAttribute("data-addon-title");
        var b = document.createElement("span");
        b.textContent = fmt(cents);
        d.appendChild(a); d.appendChild(b);
        extra.appendChild(d);
      });
      rows.forEach(function (r) {
        var row = r.closest(".arow");
        if (row) row.classList.toggle("on", r.checked);
      });
      if (baseEl) baseEl.textContent = fmt(basePrice());
      if (totalEl) totalEl.textContent = fmt(sum);
      if (bom) bom.hidden = chosen.length === 0;
    }

    /* Where a companion ships as a set of parts the buyer picks the part here.
       The select is the source of truth: it rewrites the tick box's variant and
       price before sync() reads them, so the row, the running total and the
       line that reaches /cart/add are all the same part. Without this the row
       showed the cheapest part in the set and ordered the first one. */
    $$("[data-addon-pick]", list).forEach(function (sel) {
      sel.addEventListener("change", function () {
        var label = sel.closest(".mps-add");
        if (!label) return;
        var box = $("[data-addon]", label), cost = $("[data-addon-cost]", label);
        var opt = sel.options[sel.selectedIndex];
        if (!box || !opt) return;
        var cents = parseInt(opt.getAttribute("data-price"), 10) || 0;
        box.value = opt.value;
        box.setAttribute("data-addon-price", cents);
        if (cost) cost.textContent = fmt(cents);
        sync();
      });
      /* clicking the select should not toggle the tick box it sits inside */
      sel.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); });
    });

    rows.forEach(function (r) { r.addEventListener("change", sync); });
    /* the stand's own price changes with the variant, so the total follows it */
    $$("[data-opt-radio],[data-opt-select]").forEach(function (el) {
      el.addEventListener("change", function () { setTimeout(sync, 0); });
    });
    sync();

    return {
      selected: function () {
        return rows.filter(function (r) { return r.checked; })
                   .map(function (r) { return r.value; });
      },
      sync: sync
    };
  }

  /* ══════ configurator ══════ ══════════════════════════════════════════════
     No rate card, no invented arithmetic. The visitor picks a footprint, a
     height and an illumination; we find the product in the collection that
     actually matches and show its real price and its real link. If nothing
     matches exactly we say so rather than quoting a number for a stand that
     does not exist. ─────────────────────────────────────────────────────────*/
  (function () {
    var sec = $("[data-mp-config]");
    if (!sec) return;
    var rows;
    try { rows = JSON.parse(sec.getAttribute("data-cfg-rows")); } catch (e) { return; }
    if (!rows || !rows.length) return;

    var svg = $("[data-cfg-booth]", sec), badge = $("[data-cfg-badge]", sec);
    var priceEl = $("[data-cfg-price]", sec), noteEl = $("[data-cfg-note]", sec);
    var link = $("[data-cfg-link]", sec);
    var mFoot = $("[data-cfg-m-foot]", sec), mHeight = $("[data-cfg-m-height]", sec),
        mLit = $("[data-cfg-m-lit]", sec);
    var baseNote = noteEl ? noteEl.textContent : "";
    var litWord = { full: "Backlit", feature: "Feature bays", none: "Unlit" };

    function pick() {
      var f = ($("[data-cfg-opt='f']:checked", sec) || {}).value || "";
      var h = parseFloat(($("[data-cfg-opt='h']:checked", sec) || {}).value) || 0;
      var l = ($("[data-cfg-opt='l']:checked", sec) || {}).value || "";
      var fb = f.split("x");
      var w = parseFloat(fb[0]) || 0, d = parseFloat(fb[1]) || 0;

      /* tiered match: the exact plot, then the same width, then the nearest.
         A 2 ft deep back wall is a legitimate answer to a 20 ft plot. */
      var pool = rows.filter(function (r) { return r.w === w && r.d === d; });
      if (!pool.length) pool = rows.filter(function (r) { return r.w === w; });
      if (!pool.length && w) {
        var near = Infinity;
        rows.forEach(function (r) { near = Math.min(near, Math.abs(r.w - w)); });
        pool = rows.filter(function (r) { return Math.abs(r.w - w) === near; });
      }
      if (!pool.length) pool = rows.slice();
      if (l) {
        var byLit = pool.filter(function (r) { return r.lit === l; });
        if (byLit.length) pool = byLit;
      }
      if (h) {
        var best = Infinity;
        pool.forEach(function (r) { best = Math.min(best, Math.abs(r.h - h)); });
        pool = pool.filter(function (r) { return Math.abs(r.h - h) === best; });
      }
      pool.sort(function (a, b) { return a.p - b.p; });
      return { row: pool[0], want: { w: w, d: d, h: h, l: l }, exact: pool.length > 0 };
    }

    function money(cents) {
      if (window.MP && window.MP.money) {
        return window.MP.money.replace(/\{\{\s*amount\s*\}\}/,
          (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
      }
      return "$" + (cents / 100).toFixed(2);
    }

    var lastTouched = null;

    /* Keep the control describing a stand that exists: after choosing, snap the
       axes the visitor did not just touch onto the product actually shown. */
    function reconcile(row) {
      [["h", String(row.h)], ["l", row.lit]].forEach(function (pair) {
        if (lastTouched === pair[0]) return;
        var want = $("[data-cfg-opt='" + pair[0] + "'][value='" + pair[1] + "']", sec);
        if (want && !want.checked) want.checked = true;
      });
    }

    var draw = null;
    function paint() {
      var r = pick(), row = r.row;
      if (!row) return;
      reconcile(row);

      /* re-read the controls after reconciling: what is on screen is what we judge */
      var want = pick().want;
      var litOk = !want.l || row.lit === want.l;
      var htOk = !want.h || Math.abs(row.h - want.h) < 0.05;
      var footOk = !want.w || (row.w === want.w && row.d === want.d);

      if (badge) {
        badge.textContent = row.w + " × " + row.d + " · " + row.h + " ft · " +
          (litWord[row.lit] || row.lit).toLowerCase();
      }
      if (priceEl) priceEl.textContent = (row.v ? "From " : "") + money(row.p);
      if (mFoot) mFoot.textContent = row.w + " × " + row.d + " ft";
      if (mHeight) mHeight.textContent = row.h + " ft";
      if (mLit) mLit.textContent = litWord[row.lit] || row.lit;
      if (link) { link.href = row.u; var t = $("span", link); if (t) t.textContent = "See " + row.t; }
      if (noteEl) {
        noteEl.textContent = (litOk && htOk && footOk) ? baseNote
          : "Nothing in this family is built to that exact combination. Showing the closest stand we make — " +
            row.t + ". Tell us the plot and we will work the rest out with you.";
      }

      if (!window.MPEngine || !svg) return;
      var box = svg.parentNode;
      var W = Math.max(360, box.clientWidth || 640);
      var H = Math.max(280, box.clientHeight || Math.round(W * 0.72));
      var spec = {
        w: row.w, d: row.d, h: row.h, arch: row.shape || "linear", lit: row.lit,
        sides: 1, finish: "brushed", brand: null,
        room: 0, ring: 0, ceiling: 0, counter: 0, counterLit: 0, tower: 0,
        mon85: 0, mon49: 0, shelf: 0, litstand: 0, tablet: 0, deck: 0, spare: 0,
        flight: 0, rush: 0, install: 0, storage: 0, warranty10: 0, dmx: 0, power: 0
      };
      try {
        var cfg = window.MPEngine.mkCfg(spec);
        var keep = (svg.__mp && svg.__mp.yaw !== undefined) ? svg.__mp.yaw : undefined;
        window.MPEngine.drawBooth(svg, cfg, row.lit,
          { frame: [W, H], pad: 0.08, yaw: keep });
        /* keep the visitor's chosen angle across option changes */
        svg.__mp = { cfg: cfg, lit: row.lit, pad: 0.08, yaw: keep };
        makeSpinner(svg);
      } catch (e) { /* the drawing is illustration; the price is the point */ }
    }

    $$("[data-cfg-opt]", sec).forEach(function (el) {
      el.addEventListener("change", function () {
        lastTouched = el.getAttribute("data-cfg-opt");
        if (draw) cancelAnimationFrame(draw);
        draw = requestAnimationFrame(function () { draw = null; paint(); });
      });
    });

    /* only build the drawing once the section is worth drawing */
    function start() { loadEngine().then(function () { paint(); }); }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: "400px 0px" });
      io.observe(sec);
    } else { start(); }

    var crt;
    window.addEventListener("resize", function () {
      clearTimeout(crt);
      crt = setTimeout(paint, 260);
    }, { passive: true });
  })();

  /* ══════ boot ══════ */
  function boot() { drawFigures(); initHall(); }
  boot();

  var rt, lastW = window.innerWidth;
  window.addEventListener("resize", function () {
    /* a mobile browser fires resize when the address bar hides; only a real
       width change is worth re-drawing for */
    if (Math.abs(window.innerWidth - lastW) < 40) return;
    lastW = window.innerWidth;
    clearTimeout(rt);
    rt = setTimeout(redrawDrawn, 300);
  }, { passive: true });

  document.addEventListener("shopify:section:load", boot);
})();
